var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button", 
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  {
    id: "seq_id",
    label: "Unique Key",
    type: types.INPUT,
  },
  {
    id: "approval_status",
    label: "状態",
    tab_size:15,
    type: types.SELECT_BOX,
    options: [
      "未対応", // Not supported
      "対応完了", // Completed
      "差戻", //Rejected
    ],
    table_field_style:{
      "対応完了":"color:#0e962b;",
      "未対応":"color:orange;font-weight: 600;",
      "差戻":"color:red;"
    },
    export: {
      enabled: true,
      sequence: 1000,
      surplus_license: "A",
    },
  },
  {
    id: "maker",
    label: "メーカー",
    type: types.INPUT,
    tab_size:50,
    type: types.SELECT_BOX4,
    search_mode_type_ahead:true,
    sort_result:true,
    api:"/master_maker/list_maker_name",
    on_select_event_emit_bus_key:"surplus_license_maker_software_name",
    export: {
      enabled: true,
      sequence: 1000,
      surplus_license: "B",
    },
  },
  {
    // 1
    id: "certificate_software_number", // Renamed from  "ref_id",
    label: "証書管理番号",
    type: types.INPUT,
    tab_size:30,
    import: {
      enabled: true,
      alias: ["証書管理番号\r\n(必須)"],
    },
    export: {
      enabled: true,
      sequence: 1000,
      surplus_license: "C",
    },
  },
  {
    id: "software_name",
    label: "ソフトウェア名",
    type: types.INPUT,
    tab_size:90,
    export: {
      enabled: true,
      sequence: 1000,
      surplus_license: "D",
    },
  },
  {
    //19
    id: "license",
    label: "ライセンス数",
    type: types.INPUT,
    error_if_blank: true,
    tab_size:25,
    field_type: "number",
    min_value: "0",
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      surplus_license: "E",
    },
  },
  {
    //15
    id: "expiration_date",
    label: "有効期限",
    tab_size:25,
    type: types.DATE_PICKER,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      surplus_license: "F",
    },
  },
  {
    //16
    id: "maintenance_deadline",
    label: "保守期限",
    tab_size:25,
    type: types.DATE_PICKER,
    import: { enabled: true, date_format: "YYYY-MM-DD" },
    export: {
      enabled: true, 
      sequence: 1000,
      surplus_license: "G",
   },
  },
  {
    //19
    id: "deadline_check",
    label: "期限チェック",
    tab_size:25,
    type: types.INPUT,
    error_if_blank: true,
    field_type: "number",
    min_value: "0",
    import: { enabled: true },
    export: {
      enabled: true, 
      sequence: 1000,
      surplus_license: "H",
   },
  },

  {
    id: "surplus_license_seq_id",
    label: "Reference Unique Key",
    type: types.INPUT,
  },

  {
    id: "effective_number",
    label: "有効数",
    type: types.INPUT,
    field_type:"number",
  },
  {
    id: "initial_number",
    label: "有効数_initial",// This number will not be used at the page, but exist as a reference.
    type: types.INPUT,
    field_type:"number",
  },

  {
    id: "jurisdiction_department",
    label: "所管部署",
    type: types.SELECT_BOX4,
    api: "/master_belongs/list_department",
    default_from_local_storage:"userDepartment",
  },
  {
    id: "jurisdiction_team",
    label: "所管チーム",
    type: types.SELECT_BOX4,
    api: "/master_belongs/list_team_and_department",
    default_from_local_storage:"userTeam",
  },
  {
    id: "desired_number",
    label: "希望数",
    field_type:"number",
    type: types.INPUT,
  },
  {
    id: "requester",
    label: "依頼者",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    default_from_local_storage:"userID",
  },
  {
    id: "registration_date",
    label: "登録日",
    type: types.DATE_PICKER,
  },
  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_surplus_license.js